import {
  Component,
  HostBinding,
  Input,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';
import { getComponentChildren } from 'cms/idt-components/idt-component.helpers-read';
import { RenderSlugService } from 'render/services/render-slug.service';
import { RenderStateService } from 'render/services/render-state/render-state.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { UnsubscribeComponent } from 'shared/directives/unsubscribe.component';
import { IdtComponent } from 'shared/models/idt-components/idt-component.models';

import { SliceStackedSettings } from 'extensions/core/slice-stacked/front/slice-stacked-settings.model';


@Component({
  selector: 'slice-stacked-render',
  templateUrl: './slice-stacked-render.component.html',
  styleUrls: ['./slice-stacked-render.component.scss']
})
export class SliceStackedRenderComponent extends UnsubscribeComponent implements OnInit {

  @HostBinding('style.background-color') public backgroundColor: string | undefined;

  @Input() public slice: IdtComponent<SliceStackedSettings> | undefined;

  public stackedSlices: IdtComponent[] = [];

  private readonly getRenderIdtComponents$ = this.renderStateService.getComponents$(this.renderSlugService.getSlug());

  constructor(
    private readonly cd: ChangeDetectorRef,
    private readonly renderSlugService: RenderSlugService,
    private readonly renderStateService: RenderStateService
  ) {
    super();
  }

  public ngOnInit() {
    this.getRenderIdtComponents$.pipe(
      takeUntil(this.clearSubscriptions$)
    ).subscribe(() => {
      this.cd.markForCheck();
    });

    this.getChildrenSlices();

    if (this.slice && this.slice.settings) {
      this.backgroundColor = this.slice.settings.styles.bgColor;
    }
  }

  public trackBySlice(index: number, item: IdtComponent): string {
    return item.id;
  }

  private getChildrenSlices() {
    if (!isDefined(this.slice)) {
      return;
    }

    this.getRenderIdtComponents$.pipe(
      distinctUntilChanged(),
      takeUntil(this.clearSubscriptions$)
    ).subscribe((components) => {
      this.stackedSlices = getComponentChildren(components, this.slice!);
    });
  }

}
